import { render, staticRenderFns } from "./customer-order-detail.vue?vue&type=template&id=67f577c7&scoped=true"
import script from "./customer-order-detail.vue?vue&type=script&lang=js"
export * from "./customer-order-detail.vue?vue&type=script&lang=js"
import style0 from "./customer-order-detail.vue?vue&type=style&index=0&id=67f577c7&prod&lang=scss&scoped=true"
import style1 from "./customer-order-detail.vue?vue&type=style&index=1&id=67f577c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f577c7",
  null
  
)

export default component.exports